import React,{useEffect,useState} from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form } from "react-bootstrap";
import './MobileMenu.styles.css';
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { fontWeight } from '@mui/system';
import { Slide,toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { NavigateNextTwoTone } from '@material-ui/icons';

const MobileMenu = (data) => {
  const navigate = useNavigate();
  const [headerList,setHeaderList]=useState([]);
  const [brandList,setBrandList]=useState([]);
  const [logedIn, setLogedIn] = useState(false);
  const [logedInUser, setLogedInUser] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
      // window.jQuery("#jtv-mobile-menu").mobileMenu({
      //   MenuWidth: 250,
      //   SlideSpeed: 300,
      //   WindowsMaxWidth: 767,
      //   PagePush: true,
      //   FromLeft: true,
      //   Overlay: true,
      //   CollapseMenu: true,
      //   ClassName: "jtv-mobile-menu"
      // });
      // if(headerList){
      //   setTimeout(window.mobileMenuView(), 10000)
      // }
  },[headerList])

  useEffect(() => {
    setHeaderList(data.headerList);    
    setBrandList(data.brand);
    setLogedIn(AuthVerify.isUserLogedIn());
    const user=AuthVerify.getUser();
    if(user && user.role){
      setLogedInUser(user.role);
    }
  },[data])

  const searchHandler =()=>{
    if(searchValue && searchValue!="")
        navigate(`/search?keyword=${searchValue}`)
    else
        toast.warning('Please enter product name for search.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            transition: Slide,
        });
  }

  const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
          searchHandler();
      }
  }

  const navigateTo=(url)=>{
    window.mobileMenuView();
    navigate(url);
  }

  var RenderData = () =>{
    var count=0;
    return (
      <>
        <li>
          <input type="checkbox" id={`cb${++count}`}/><label for={`cb${count}`}>&nbsp;</label><button onClick={() => navigateTo("/category?name=all")}>Categories</button>
          {headerList.map((data,i) => (
            <ul  key={i}>
              <li><input type="checkbox" id={`cb${++count}`}/><label for={`cb${count}`}>&nbsp;</label><button onClick={() => navigateTo(data?.grp?.newUrl)}>{data?.grp?.varname}</button>
                {data?.subgrp?.map((subcategory,k) => (
                      <ul key={k}>
                        <li><label>&nbsp;</label><button onClick={() => navigateTo(subcategory?.grp?.newUrl)}>{subcategory?.grp?.varname}</button></li>
                      </ul>
                ))
              }
              </li>
            </ul>
          ))}
          {/* <ul>
            <li><input type="checkbox" id="cb2"/><label for="cb2">Level 2-A</label>
                <ul>
                  <li><label>Level 3-A</label></li>
                  <li><label>Level 3-B</label></li>
                </ul>
            </li>
            <li><input type="checkbox" id="cb3"/><label for="cb3">Level 2-B</label>
            <ul>
              <li><input type="checkbox" id="cb5"/><label for="cb5">Level 3-A</label>
                <ul>
                  <li><label>Level 4-A</label></li>
                  <li><label>Level 4-B</label></li>
                  <li><label>Level 4-C</label></li>
                  <li><label>Level 4-D</label></li>
                </ul>
              </li>
              <li><input type="checkbox" id="cb6"/><label for="cb6">Level 3-B</label>
                <ul>
                  <li><label>Level 4-A</label></li>
                  <li><label>Level 4-B</label></li>
                </ul>
              </li>
              <li><input type="checkbox" id="cb7"/><label for="cb7">Level 3-C</label>
                <ul>
                  <li><label>Level 4-A</label></li>
                  <li><label>Level 4-B</label></li>
                  <li><label>Level 4-C</label></li>
                </ul>
              </li>
            </ul>
            </li>
            <li><input type="checkbox" id="cb4"/><label for="cb4">Level 2-C</label>
                <ul>
                  <li><label>Level 3-A</label></li>
                </ul>
            </li>
          </ul> */}
        </li>   
      </>
    );
  };

  var RenderSettings = () =>{
    var count=99999;
    return (
      <>
      {
        logedInUser && logedInUser=="Corporate" &&
        <li>
          <input type="checkbox" id={`cb${++count}`}/><label for={`cb${count}`}>&nbsp;</label><button onClick={() => navigateTo("/my-account")}>Corporate Settings</button>
  
            <ul>
            {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=MyGeneralProfile")}>My Profile</button></li>
            }
            {AuthVerify.getPermissions("Corporateprofile")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=corporateprofile")}>Corporate Profile</button></li>
            }
            {AuthVerify.getPermissions("ShippingAddress")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=shippingAddress")}>Shipping Address</button></li>
            }
            {AuthVerify.getPermissions("Staff")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=staff")}>Staff</button></li>
            }
            {AuthVerify.getPermissions("CostCenter")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Cost")}>Cost Center</button></li>
            }
            {AuthVerify.getPermissions("Catalog")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Catalog")}>Catalog</button></li>
            }
            {AuthVerify.getPermissions("Budget")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Budget")}>Budget</button></li>
            }
            {AuthVerify.getPermissions("ProductMapping")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=ProductMapping")}>Product Mapping</button></li>
            }
            {AuthVerify.getPermissions("ChartOfAccount")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=ChartOfAccount")}>Chart Of Accounts</button></li>
            }
            </ul>
        </li>   
      }
      {
        logedInUser && logedInUser=="Individual" &&
        <li>
          <input type="checkbox" id={`cb${++count}`}/><label for={`cb${count}`}>&nbsp;</label><button onClick={() => navigateTo("/my-account")}>My Settings</button>
  
            <ul>
            {AuthVerify.getPermissions("MyProfile")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=MyProfile")}>My Profile</button></li>
            }
            {AuthVerify.getPermissions("ShippingAddress")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=shippingAddress")}>Shipping Address</button></li>
            }
            {AuthVerify.getPermissions("MyOrders")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Orders")}>My Orders</button></li>
            }
            {AuthVerify.getPermissions("MyOrderTemplate")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Templates")}>My Order Template</button></li>
            }
            {AuthVerify.getPermissions("Invoices")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Invoices")}>My Invoices</button></li>
            }
            {AuthVerify.getPermissions("MyReturns")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Returns")}>My Returns</button></li>
            }
            {AuthVerify.getPermissions("MyWishlist")?.menuaccess && 
              <li><label>&nbsp;</label><button onClick={() => navigateTo("/my-account?activeKey=Wishlist")}>My Wishlist</button></li>
            }
            </ul>
        </li>   
      }
      </>
    );
  };

  return (
    <>
     
      <div id="jtv-mobile-menu">
      {/* <br />
      <Row>
        <Col lg={4} md={4} sm={4} xs={12}> 
          <div className="search-box" style={{marginTop:"0px",width:"100%"}}>
              <input
                  type="text"
                  placeholder="Search keywords for products..."
                  maxLength="70"
                  // name="search"
                  className='pressEnterAction'
                  value={searchValue}
                  onChange={e=>setSearchValue(e.target.value)}
                  id="search"
              />
              <button type="button"  id='pressEnterActionBtn' className="search-btn-bg" onClick={searchHandler}>
                  <span className="glyphicon glyphicon-search"></span>&nbsp;
              </button>
          </div>
          </Col>
      </Row>
      <br/> */}
      <ul>
      <li>
          <div className="jtv-search-mob">
          <div id="search1" name="search">
              <div className="input-group">
                <input type="text" 
                style={{marginTop:"0"}}
                value={searchValue}
                onChange={e=>setSearchValue(e.target.value)}
                className="form-control simple" placeholder="Search ..." name="srch-term" id="srch-term" />
                <div className="input-group-btn">
                  <button className="btn btn-default" type="button" onClick={searchHandler}><i className="fa fa-search"></i> </button>
                </div>
              </div>
          </div>
          <div>
            <button className="btn btn-default menuHideBtn" type="button" onClick={()=>window.mobileMenuView()}>X</button>
          </div>
          </div>
        </li>
        <RenderData/>
        <RenderSettings/>
      </ul>
      <div className="jtv-top-link-mob">
        <ul className="links">
          {data.activeC &&  <li><a title="Checkout" href="/category?name=all">&nbsp; My Catalog</a> </li>}
          {/* <li><a title="My Account" href="/helpdesk"><span>&nbsp; Help Desk</span></a> </li> */}
          <li><a title="My Account" href="/contactus"><span>&nbsp; Contact Us</span></a> </li>
          <li><a title="My Account" href="/faqs"><span>&nbsp; FAQs</span></a> </li>
          {/* <li><a title="My Account" href="/send-us-message"><span>&nbsp; Send us Message</span></a> </li> */}
          
          {
            logedIn ? 
            <>
            <li><a title="Checkout" href="/shopping-cart">&nbsp; Checkout</a> </li>
            <li><a title="My Account" href="/my-account"><span>&nbsp; My Account</span></a> </li>
            </>
            :
            <>
            <li><a title="Sign up" href="/signup"><span>&nbsp; Sign up/Login</span></a> </li>
            {/* <li><a title="Login" href="/login"><span>&nbsp; Login</span></a> </li> */}
            </>
            
          }
          
        </ul>
      </div>
      </div>
    </>
  );

};

export default MobileMenu;
